import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import KO from "./ko.json";
import KO_EXT from "./ko_ext.json";
import JA from "./ja.json";
import JA_EXT from "./ja_ext.json";
import EN from "./en.json";
import EN_EXT from "./en_ext.json";
import { SupportedLanguages } from "../models/cacheKey";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV !== "production",
    fallbackLng: "en",
    interpolation: { escapeValue: false, prefix: "{", suffix: "}" },
    supportedLngs: SupportedLanguages,
    lowerCaseLng: true,
    load: "languageOnly",
    resources: {
      ko: { translation: { ...KO, ...KO_EXT } },
      ja: { translation: { ...JA, ...JA_EXT } },
      en: { translation: { ...EN, ...EN_EXT } },
    },
    detection: {
      lookupLocalStorage: "lang",
    },
  })
  .then();

export default i18n;
